import { keepPreviousData } from '@tanstack/react-query';

import {
  type GetQuizsetRankingsSummarySchoolType,
  useGetQuizsetRankingsSummary,
} from '@/api';
import { useCountryCode } from '@/shared/hooks';

/**
 *
 * FeaturedQuizzesAside
 * RollingBanner
 * 에서 사용
 * */
export const useFetchFeaturedQuizzesSummary = ({
  schoolType,
}: {
  schoolType: string;
}) => {
  const { isLoading, countryCode } = useCountryCode();

  const result = useGetQuizsetRankingsSummary(
    {
      ...(schoolType &&
        schoolType.toLowerCase() !== 'all' && {
          schoolType: schoolType as GetQuizsetRankingsSummarySchoolType,
        }),
      countryCode: countryCode,
    },
    {
      query: {
        enabled: !isLoading,
        placeholderData: keepPreviousData,
      },
    },
  );
  return {
    ...result,
    isLoading: isLoading || result.isLoading,
  };
};
